// noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols

import {Nullable} from "./caos-def";


const intRegex = /[0-9]+/;
const numberRegex = /([0-9]+|[0-9]*\.[0-9]+)([eE][0-9]+)?/;

export function isInt(value: unknown): value is number {
    if (typeof value === "number") {
        return true;
    }

    if (typeof value === "string") {
        return intRegex.test(value);
    }

    return false;
}

export function asInt(value: unknown, radix: number = 10): Nullable<number> {
    if (typeof value === "number") {
        return value;
    }

    if (typeof value === "string") {
        if (intRegex.test(value)) {
            return parseInt(value, radix);
        }
        if (numberRegex.test(value)) {
            return Math.round(parseFloat(value));
        }
    }

    if (typeof value === "boolean") {
        return value ? 1 : 0;
    }
    return null;
}

export function asFloat(value: unknown): Nullable<number> {
    if (typeof value === "number") {
        return value;
    }

    if (typeof value === "string" && numberRegex.test(value)) {
        return parseFloat(value);
    }

    if (typeof value === "boolean") {
        return value ? 1.0 : 0.0;
    }

    try {
        console.error("Value is not numeric; Value: ", value);
    } catch (_e) { /* empty */
    }

    return null;
}

export function asNumber(value: unknown, radix: number = 10): Nullable<number> {
    if (typeof value === "number") {
        return value;
    }

    if (typeof value === "string") {
        if (intRegex.test(value)) {
            return parseInt(value, radix);
        }
        if (numberRegex.test(value)) {
            return parseFloat(value);
        }
    }

    if (typeof value === "boolean") {
        return value ? 1 : 0;
    }

    try {
        console.error("Value is not a number; Value: ", value);
    } catch (_e) { /* empty */
    }

    return null;
}


export function isNumeric(value: unknown): boolean {
    if (typeof value === "number") {
        return true;
    }

    if (typeof value === "string") {
        return numberRegex.test(value);
    }

    return false;
}


export function asBoolean(value: unknown, defaultValue?: Nullable<boolean>): Nullable<boolean> {

    if (value == null) {
        return defaultValue;
    }

    if (typeof value === "boolean") {
        return value;
    }

    if (typeof value === "string") {
        switch (value.toLowerCase()) {
            case "true":
            case "t":
            case "1":
            case "yes":
            case "y":
                return true;
            case "false":
            case "f":
            case "0":
            case "no":
            case "n":
                return false;
            default:
                return defaultValue;
        }
    }

    if (typeof value === "number") {
        if (value === 1) {
            return true;
        } else if (value == 0) {
            return false;
        } else {
            return defaultValue;
        }
    }

    return defaultValue;
}


export function localStorageGetBoolean(key: string, defaultValue?: Nullable<boolean>): Nullable<boolean> {
    const value = localStorage.getItem(key);
    if (value == null || value.trim().length === 0) {
        return defaultValue;
    }
    return asBoolean(value, defaultValue);
}

export function localStorageGetBooleanNotNull(key: string, defaultValue: boolean): boolean {
    const value = localStorage.getItem(key);
    if (value == null || value.trim().length === 0) {
        return defaultValue;
    }
    return asBoolean(value, defaultValue) ?? defaultValue;
}